// extracted by mini-css-extract-plugin
export default {"SystemMessage":"ChatStateMachine_SystemMessage__YZTz0"};